export class SalesPageSettings {
  page: number;
  size: number;
  sort: string;
  order: string;
}

export const defaultSalesPageSettings = {
  size: 25, // if changed please see for offering.component, too
  page: 0,
  sort: 'EXPIRATION',
  order: 'ASC'
} as SalesPageSettings;